import { TraceXInterceptor } from '@trace-x/trace-x-generator';
// tslint:disable:variable-name
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Utils } from '../utils/utils';

@Injectable({
  providedIn: 'root',
})
export class TariffFormHandlerService {
  hotels = new BehaviorSubject([]);
  countries = new BehaviorSubject([]);
  cities = new BehaviorSubject([]);
  cityMap = new BehaviorSubject(new Map());
  _hotels = [];
  _countries = [];
  _cities = [];
  _cityMap = new Map<string, Array<any>>();

constructor() {}

/**
 * Set countries.
 * @param list The list of countries.
 */
setCountries(list) {
  TraceXInterceptor.interceptTrace('dashboard/projects/surf-tariff-search/src/lib/services/tariff-form-handler.service.ts.TariffFormHandlerService.setCountries');
  this._countries = [];
  Utils.updateValue(list);
  list.forEach((country) => this._countries.push(country));
  this.countries.next(this._countries);
}

  setCities(list) {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tariff-search/src/lib/services/tariff-form-handler.service.ts.TariffFormHandlerService.setCities');
    this._cities = [];
    this._cityMap = new Map();
    Utils.updateValue(list);
    list.forEach((city) => {
      this._cities.push(city);
      const country = city.parent.find((item) => item.type === 'COUNTRY');
      if (country) {
        this.addToCityMap(country.code, city);
      }
    });
    this.cities.next(this._cities);
    this.cityMap.next(this._cityMap);
  }

  addToCityMap(key, value) {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tariff-search/src/lib/services/tariff-form-handler.service.ts.TariffFormHandlerService.addToCityMap');
    if (this._cityMap.has(key)) {
      this._cityMap.get(key).push(value);
    } else {
      const arr = [value];
      this._cityMap.set(key, arr);
    }
  }

  getCitiesByCountry(code) {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tariff-search/src/lib/services/tariff-form-handler.service.ts.TariffFormHandlerService.getCitiesByCountry');
    return this._cityMap.get(code);
  }
}
